import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"display":"inline-block"}
}
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "d-flex justify-content-between" }

import { computed, toRef } from 'vue'

    import type { AlternativeFilterReadModel } from '@Alternatives/AlternativesViews/Domain/readmodels'
    import type { AttributeReadModel } from '@Alternatives/Attributes/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeFilter',
  props: {
    propRm: {},
    propAttributes: {}
  },
  emits: ["deleteFilter"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'propRm')
    const attributes = toRef(props, 'propAttributes')

    // ---------------- derived ----------------

    const valueRequired = computed(() =>
        rm.value.Type !== 'PropertyIsKnown' &&
        rm.value.Type !== 'PropertyIsUnknown'
    )

    const opText = computed(() =>
    {
        switch (rm.value.Type)
        {
            case 'PropertyEq': return 'equals'
            case 'PropertyNotEq': return 'not equals'
            case 'PropertyLt': return 'less then'
            case 'PropertyLte': return 'less then or equal'
            case 'PropertyGt': return 'greater then'
            case 'PropertyGte': return 'greater then or equal'
            case 'PropertyIsKnown': return 'is known'
            case 'PropertyIsUnknown': return 'is unknown'
            case 'PropertyContains': return 'contains'
            default: return ''
        }
    })

    const headerText = computed(() =>
    {
        const attr = (attributes.value || []).find(a => a.Name === rm.value.Data.Name)

        if (!attr)
            return 'Choose attribute...'

        if (!rm.value.Data.Value && valueRequired.value)
            return 'Set condition...'

        return `${attr.Name} ${opText.value} ${valueRequired.value ? rm.value.Data.Value : ''}`
    })

    // ---------------- methods ----------------

    function deleteFilter()
    {
        emit('deleteFilter', rm.value)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (rm.value.IsEdited = true)),
      class: "card-header pointer"
    }, _toDisplayString(headerText.value), 1 /* TEXT */),
    (rm.value.IsEdited)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Attribute:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rm.value.Data.Name) = $event)),
              class: "form-control"
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "Choose...", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: attr.Name
                }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_4))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, rm.value.Data.Name]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, _toDisplayString(_ctx.OpText) + ":", 1 /* TEXT */),
            (valueRequired.value)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rm.value.Data.Value) = $event)),
                  class: "form-control"
                }, null, 512 /* NEED_PATCH */)), [
                  [_vModelText, rm.value.Data.Value]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", { class: "dropdown d-inline" }, [
              _cache[7] || (_cache[7] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-danger",
                "data-toggle": "dropdown"
              }, " Delete ", -1 /* CACHED */)),
              _createElementVNode("div", { class: "dropdown-menu" }, [
                _createElementVNode("div", { class: "btn-group" }, [
                  _cache[6] || (_cache[6] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Cancel", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    onClick: deleteFilter,
                    type: "button",
                    class: "btn btn-danger"
                  }, "Confirm")
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (rm.value.IsEdited = false)),
              class: "btn btn-primary"
            }, "Update")
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})